<template>
  <div id="BlocPhoto">
    <img class="imgPortrait" :src="require('./img/' + img)" alt="imgPortrait" />
    <div class="name mt-3">
      {{ name }}
    </div>
    <div class="post mt-3">
      {{ post }}
    </div>
    <div class="mt-3">
      <a :href="link" v-if="link.length > 1">
        <img class="imgLink" src="./img/linkedin.png" alt="" />
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: ["name", "post", "link", "img"]
};
</script>
<style lang="scss">
@import "../../../../../sass/_variables.scss";

#BlocPhoto {
  background: var(--unnamed-color-f5f5f5) 0% 0% no-repeat padding-box;
  background: $bg_color 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 33px;
  opacity: 1;
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;

  .imgPortrait {
    border-radius: 60px;
    width: 120px;
    border: 3px solid white;
  }

  .imgLink {
    width: 20px;
    border-radius: 5px;
  }

  .name {
    font: var(--unnamed-font-style-normal) normal
      var(--unnamed-font-weight-bold) var(--unnamed-font-size-30) /
      var(--unnamed-line-spacing-40) var(--unnamed-font-family-segoe-ui);
    letter-spacing: var(--unnamed-character-spacing-0);
    color: var(--unnamed-color-707070);
    text-align: center;
    font: normal normal bold $mf_ft_size_text Segoe UI;
    letter-spacing: 0px;
    color: $mf_ft_color_lt;
    opacity: 1;
  }

  .post {
    font: var(--unnamed-font-style-normal) normal
      var(--unnamed-font-weight-normal) 25px/33px
      var(--unnamed-font-family-segoe-ui);
    letter-spacing: var(--unnamed-character-spacing-0);
    color: var(--unnamed-color-707070);
    text-align: center;
    font: normal normal bold $mf_ft_size_small_text Segoe UI;
    letter-spacing: 0px;
    color: $mf_ft_color_lt;
    opacity: 1;
  }
}
</style>